var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dir":"rtl"}},[(_vm.showDesk)?_c('div',[(_vm.showBarRight)?_c('main-bar-right'):_vm._e()],1):_vm._e(),(_vm.showDesk)?_c('div',[(_vm.showBarRight)?_c('main-bar-top'):_vm._e()],1):_vm._e(),(_vm.showMobile)?_c('div',[(_vm.showBarRight)?_c('mobileright-bar'):_vm._e()],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }